<div class="dialog-container">
  <div class="dialog-header"
       layout="row"
       layout-align="space-between center">
    <h2 mat-dialog-title>{{ 'creditLimitOffers.createLimitOffer' | translate }}</h2>
    <button mat-icon-button
            class="margin-right-16px"
            (click)="onCancel()"
            tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="offerForm"
          (ngSubmit)="onSubmit()">
      <div layout="row"
           layout-align="start center">
        <mat-form-field flex="50">
          <mat-label>{{ 'creditLimitOffers.amount' | translate }}</mat-label>
          <input matInput
                 required
                 type="number"
                 formControlName="amount"
                 min="1" />
          <span class="value-type"
                matSuffix>{{ defaultCurrencySymbol }}</span>
          @if (offerForm.get('amount')?.hasError('required')) {
          <mat-error>{{ 'forms.required' | translate }}</mat-error>
          }
          @if (offerForm.get('amount')?.hasError('min')) {
          <mat-error [translate]="'forms.positiveNumber'">The value must be a
            positive number</mat-error>
          }
        </mat-form-field>

        <mat-form-field flex="50">
          <mat-label>{{ 'creditLimitOffers.validTo' | translate }}</mat-label>
          <input matInput
                 required
                 [min]="tomorrowDate"
                 [matDatepicker]="toPicker"
                 formControlName="validTo" />
          <mat-datepicker-toggle matSuffix
                                 [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker [touchUi]="false"
                          #toPicker></mat-datepicker>
          @if (offerForm.get('validTo')?.hasError('required')) {
          <mat-error>{{ 'forms.required' | translate }}</mat-error>
          }
          <mat-hint>дд/мм/ГГГГ</mat-hint>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      class="dialog-actions">
    <button mat-raised-button
            class="margin-right-24px"
            color="primary"
            (click)="onSubmit()"
            [disabled]="isLoading">
      <div layout="row"
           layout-align="center center">
        @if (isLoading) {
        <mat-spinner diameter="20"></mat-spinner>
        } @else {
        <span>{{ 'global.create' | translate }}</span>
        }
      </div>
    </button>
  </mat-dialog-actions>
</div>
